import axios from 'axios';

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const resolveMedia = (url) => (url && url.startsWith('/api/') ? `${BACKEND}${url}` : url || '');

export const youtubeId = (url = '') => {
  const m = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
  return m ? m[1] : '';
};

export const detectMediaType = (url = '', mime = '') => {
  if (youtubeId(url)) return 'youtube';
  if (mime.startsWith('video') || /\.(mp4|webm|mov|m4v)(\?|$)/i.test(url)) return 'video';
  return 'image';
};

export async function uploadMedia(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post(`${API}/upload`, fd, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' } });
  return { url: `/api/files/${res.data.storage_path}`, type: detectMediaType(file.name, file.type || '') };
}

const mapQueryFromLink = (link = '') => {
  if (!link) return '';
  const at = link.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (at) return `${at[1]},${at[2]}`;
  const q = link.match(/[?&](?:q|query|destination)=([^&]+)/);
  if (q) return decodeURIComponent(q[1].replace(/\+/g, ' '));
  const place = link.match(/\/place\/([^/]+)/);
  if (place) return decodeURIComponent(place[1].replace(/\+/g, ' '));
  return '';
};

export const mapEmbedSrc = ({ map_link = '', address = '', name = '' }) => {
  if (map_link.includes('/maps/embed')) return map_link;
  const q = mapQueryFromLink(map_link) || [name, address].filter(Boolean).join(', ');
  return q ? `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed` : '';
};

export const directionsHref = ({ map_link = '', address = '', name = '' }) =>
  map_link && !map_link.includes('/maps/embed')
    ? map_link
    : `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent([name, address].filter(Boolean).join(', '))}`;

export const fmtEventDate = (iso, opts = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }) => {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('en-IN', opts);
};

export const fmtEventTime = (iso) => {
  if (!iso || !iso.includes('T')) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit' });
};
